import { useId } from "react";
import { cn } from "@/core/helpers/cn";

export function SmartphoneIcon({ className }: { className?: string }) {
  const id = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 28"
      className={cn("w-[18px] h-[28px]", className)}
    >
      <path
        fill="#fff"
        fillOpacity=".2"
        d="M14.34 0H3.66c-.97 0-1.9.4-2.59 1.1A3.75 3.75 0 0 0 0 3.71v20.56c0 .98.39 1.93 1.07 2.63.69.7 1.62 1.09 2.59 1.09h10.68c.97 0 1.9-.4 2.59-1.1a3.75 3.75 0 0 0 1.07-2.6V3.72a3.8 3.8 0 0 0-1.07-2.63A3.65 3.65 0 0 0 14.34 0Zm-3.87 26.57H7.64a1.21 1.21 0 0 1-1.23-.74 1.25 1.25 0 0 1 .73-1.67c.16-.06.33-.08.5-.06h2.83a1.2 1.2 0 0 1 .94.32 1.24 1.24 0 0 1 .3 1.41 1.24 1.24 0 0 1-.74.68 1.4 1.4 0 0 1-.5.06Zm2.36-22.04H5.17c-.32 0-.63-.13-.86-.36a1.25 1.25 0 0 1 0-1.75c.23-.24.54-.37.86-.37h7.66a1.25 1.25 0 0 1 .87 2.12c-.24.23-.55.36-.87.36Z"
      />

      <path
        fill={`url(#${id})`}
        fillOpacity=".3"
        d="M14.34 0H3.66c-.97 0-1.9.4-2.59 1.1A3.75 3.75 0 0 0 0 3.71v20.56c0 .98.39 1.93 1.07 2.63.69.7 1.62 1.09 2.59 1.09h10.68c.97 0 1.9-.4 2.59-1.1a3.75 3.75 0 0 0 1.07-2.6V3.72a3.8 3.8 0 0 0-1.07-2.63A3.65 3.65 0 0 0 14.34 0Zm-3.87 26.57H7.64a1.21 1.21 0 0 1-1.23-.74 1.25 1.25 0 0 1 .73-1.67c.16-.06.33-.08.5-.06h2.83a1.2 1.2 0 0 1 .94.32 1.24 1.24 0 0 1 .3 1.41 1.24 1.24 0 0 1-.74.68 1.4 1.4 0 0 1-.5.06Zm2.36-22.04H5.17c-.32 0-.63-.13-.86-.36a1.25 1.25 0 0 1 0-1.75c.23-.24.54-.37.86-.37h7.66a1.25 1.25 0 0 1 .87 2.12c-.24.23-.55.36-.87.36Z"
      />

      <defs>
        <linearGradient
          id={id}
          x1="14.56"
          x2="-4.64"
          y1="28"
          y2="20.38"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity="0" />
          <stop offset=".5" stopColor="#fff" stopOpacity=".2" />
          <stop offset="1" stopColor="#fff" />
        </linearGradient>
      </defs>
    </svg>
  );
}
